"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLanguage = void 0;
var _react = require("react");
var _translationsContext = require("../translationsContext");
/**
 * Custom hook for accessing current language provided to TranslationsProvider.
 *
 * @returns Language which contains translations and related information.
 */

const useLanguage = () => {
  const {
    language = ''
  } = (0, _react.useContext)(_translationsContext.translationsContext);
  return (0, _react.useMemo)(() => ({
    language
  }), [language]);
};
exports.useLanguage = useLanguage;
